export function wrapForcedLayout<T>(_source: string, fn: () => T): T {
    const result = fn();
    return result;
}
